import { useState } from "react";
import { X } from "lucide-react";
import { Reveal, ScriptKicker, FilipinoSun } from "../components/Reveal";
import { GALLERY_IMAGES } from "../lib/data";
import { usePageMeta } from "../hooks/usePageMeta";

export default function Gallery() {
  usePageMeta({
    title: "Filipino Catering Gallery | Ateng K Sarap San Diego",
    description:
      "See real Filipino catering spreads — pansit, lechon, lumpia & more — from Ateng K Sarap events across San Diego.",
    path: "/gallery",
  });
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <div data-testid="gallery-page" className="overflow-hidden">
      <section className="relative pt-20 pb-12 lg:pt-32 lg:pb-16 bg-background">
        <div className="absolute top-16 left-10 text-accent/25 hidden lg:block"><FilipinoSun size={100} /></div>
        <div className="container-eds relative">
          <div className="overline flex items-center gap-3"><span className="w-8 h-px bg-secondary" /> Gallery</div>
          <ScriptKicker className="block mt-3">Moments worth keeping</ScriptKicker>
          <h1 className="mt-2 font-display text-5xl sm:text-6xl lg:text-7xl font-medium text-foreground leading-[0.98] tracking-tight max-w-4xl">
            Filipino feasts, <span className="italic text-secondary">celebrations</span>,
            <br />
            and warm <span className="italic text-primary">moments</span>.
          </h1>
          <p className="mt-6 text-muted-foreground text-base lg:text-lg max-w-2xl">
            Peek inside our catering setups, signature dishes, and the joyful
            gatherings we've had the honor of feeding.
          </p>
        </div>
      </section>

      <section className="py-12 lg:py-20 bg-background">
        <div className="container-eds">
          <div className="masonry">
            {GALLERY_IMAGES.map((src, i) => {
              const rots = ["rotate-l1", "rotate-r1", "rotate-l2", "rotate-r2", "", ""];
              return (
                <Reveal key={i} delay={(i % 6) * 0.05}>
                  <button
                    type="button"
                    data-testid={`gallery-item-${i}`}
                    onClick={() => setActiveIdx(i)}
                    className={`block w-full polaroid hover:rotate-0 transition-all duration-500 ${rots[i % 6]} hover:scale-[1.02] hover:shadow-2xl`}
                  >
                    <img src={src} alt={`Gallery ${i + 1}`} loading="lazy" decoding="async" className="w-full h-auto object-cover" />
                    <div className="polaroid-caption">Ateng K Sarap · {String(i + 1).padStart(2, "0")}</div>
                  </button>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {activeIdx !== null && (
        <div
          data-testid="lightbox-overlay"
          className="fixed inset-0 z-[100] bg-foreground/95 flex items-center justify-center p-4 sm:p-12"
          onClick={() => setActiveIdx(null)}
        >
          <button
            type="button"
            data-testid="lightbox-close"
            className="absolute top-6 right-6 text-background p-2 hover:text-accent transition-colors"
            onClick={(e) => { e.stopPropagation(); setActiveIdx(null); }}
            aria-label="Close"
          >
            <X className="w-8 h-8" />
          </button>
          <img src={GALLERY_IMAGES[activeIdx]} alt="Enlarged" className="max-w-full max-h-full object-contain" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
